import { Controller } from "@hotwired/stimulus"

// Tab switcher for CMS forms with per-locale sections. Attach to a wrapper
// that contains both the tab buttons (`data-locale-tabs-target="tab"`) and
// the locale panels (`data-locale-tabs-target="panel"`); each element also
// has `data-locale="ru|en|es"` so the controller knows which pair goes
// together.
//
// Usage:
//   <div data-controller="locale-tabs" data-locale-tabs-active-value="ru">
//     <div class="tabs">
//       <button type="button" data-locale-tabs-target="tab" data-locale="ru"
//               data-action="click->locale-tabs#switch">RU</button>
//       <button type="button" data-locale-tabs-target="tab" data-locale="en"
//               data-action="click->locale-tabs#switch">EN</button>
//     </div>
//     <div data-locale-tabs-target="panel" data-locale="ru">…</div>
//     <div data-locale-tabs-target="panel" data-locale="en">…</div>
//   </div>
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values  = { active: { type: String, default: "ru" } }

  connect() {
    this.applyActive(this.activeValue)
  }

  switch(event) {
    event.preventDefault()
    const locale = event.currentTarget.dataset.locale
    if (locale) this.applyActive(locale)
  }

  applyActive(locale) {
    this.activeValue = locale
    this.tabTargets.forEach(t => {
      t.classList.toggle("active", t.dataset.locale === locale)
    })
    this.panelTargets.forEach(p => {
      p.hidden = p.dataset.locale !== locale
    })
  }
}
